module.exports = __webpack_public_path__ + "c0114cafaaab9eac3a95ea7b0c747af2.svg";